import "./lib/antdReact19";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import store from "./store";
import { App as AntdApp, ConfigProvider, theme as antdTheme } from "antd";
import es_ES from "antd/es/locale/es_ES";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { ThemeProvider, useTheme } from "./theme/ThemeContext";
import { environment } from "./configuration";
import { initBackOfficeAnalytics } from "./lib/posthog";
import { AntdAppApiBridge } from "./lib/antdAppApi";
import './App.css'

initBackOfficeAnalytics();

// ConfigProvider must live below ThemeProvider so the antd algorithm can
// react to theme toggles; the SCSS side reacts via data-theme on <html>.
const ThemedApp = () => {
  const { theme } = useTheme();

  return (
    <ConfigProvider
      locale={es_ES}
      theme={{
        algorithm:
          theme === "dark"
            ? antdTheme.darkAlgorithm
            : antdTheme.defaultAlgorithm,
        token: { colorPrimary: "#65558F" },
      }}
    >
      {/* AntdApp provee el contexto para message/notification/modal en antd v5:
          los componentes lo usan con App.useApp(), porque la API estática
          (message.success) no se renderiza con React 19 sin el patch de
          compatibilidad. AntdAppApiBridge expone esas mismas instancias al
          código fuera de componentes (src/lib/antdAppApi.tsx). */}
      <AntdApp>
        <AntdAppApiBridge />
        <App />
      </AntdApp>
    </ConfigProvider>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

// Loads Google Identity Services once for the whole app (SCRUM-706). It is
// the sole sign-in path, so it wraps everything rather than just /login.
root.render(
  <GoogleOAuthProvider clientId={environment.googleClientId} locale="es">
    <Provider store={store}>
      <ThemeProvider>
        <ThemedApp />
      </ThemeProvider>
    </Provider>
  </GoogleOAuthProvider>
);
